import { Component, AfterViewInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { MatTableDataSource } from '@angular/material/table';
import { ComplaintsService } from '../../service/complaints.service'
import { session } from 'src/environments/environment.session';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../shared/spinner.service';
import { ExcelService } from '../../service/file-export.service'
import { Router } from '@angular/router';
import { PdfGeneratorService } from '../../service/pdf-generator.service';

@Component({
  selector: 'app-complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.css']
})
export class ComplaintComponent {
  // departmentMappings: any[]= [];
  // filteredDepartmentList: any[] = [];
  complaints: any[] = [];
  showComplaints: any[] = [];
  searchText: string = '';
  myNumber = 50;
  displayedColumns: string[] = ['id', 'dept', 'zone', 'ward', 'created', 'days_Open'];
  dataSource: any = [
  ];
  allComplaints: any[] = []
  constructor(private pdfService: PdfGeneratorService, private excel: ExcelService, private cs: ComplaintsService, public mainService: MainService, private tspinner: SpinnerService, private router: Router) {

  }

  currentPage = 1;
  pageSize = 10;
  totalPages = 0;
  page_list = [10, 20, 50, 100];
  totalRecords: any = 0;

  erpUser: any
  async ngOnInit() {

    this.erpUser = JSON.parse(atob(session.erpUser));
    // this.complaints.filterPredicate = (data:any, filter: any) => {
    //   const dataStr = Object.values(data).join('').toLowerCase();
    //   return dataStr.includes(filter);
    // };

    await this.getComplaints()

  }

  department = {};

  async getComplaints() {
    const obj = { b_acct_id: this.erpUser.b_acct_id,};

    this.tspinner.show('', '');

    try {
      const resp = await this.cs.getComplaints(JSON.stringify(obj));
      this.tspinner.hide();

      if (resp.error === false) {
        this.allComplaints = resp.data.map((complaint: any) => {
          try {
            const deptArray = JSON.parse(complaint.dept || '[]');
            complaint.departments = deptArray.map((item: any) => Object.values(item));
          } catch (err) {
            complaint.departments = [];
          }
          return complaint;
        });

        await this.applyFilters();
      } else {
        Swal.fire('Oops!!', resp.data, 'error');
      }
    } catch (err) {
      this.tspinner.hide();
      console.error('Error fetching complaints:', err);
      Swal.fire('Oops!!', 'Something went wrong.', 'error');
    }
  }
  onDownloadPDF(obj: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, obj.com_id);
  }

  ngAfterViewInit(): void {
    this.mainService.dataSource = this.allComplaints
  }


  applyFilters(): void {
    const value = this.searchText.trim().toLowerCase();
    if (!value) {
      this.complaints = [...this.allComplaints];
      this.totalRecords = this.complaints.length;
      this.updatePagedData();
      this.updatePages();
      return;
    }


    this.complaints = this.allComplaints.filter((item: any) =>
      (item.zone && item.zone.toLowerCase().includes(value)) ||
      (item.zone && item.ward.toLowerCase().includes(value)) ||
      (item.create_date && item.create_date.toLowerCase().includes(value))
      // (item.number_of_open_days && item.number_of_open_days.toLowerCase().includes(value))
      // (item.status && item.status.toLowerCase().includes(value))
      // (item.dep && item.dep.includes(value))
    );

    this.totalRecords = this.complaints.length
    this.updatePages();
    this.updatePagedData();

  }

  updatePages(): void {
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
  }

  updatePagedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.showComplaints = this.complaints.slice(start, end);
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  changePageSize(): void {
    this.currentPage = 1;
    this.updatePages();
    this.updatePagedData();
  }

  onSearchChange(): void {
    this.currentPage = 1;
    this.applyFilters();
  }
  route(element: any) {
    this.router.navigate(['/sdp/complaints/preview'], {
      state: { data: element }
    });
  }


  exportToExcel(): void {
    this.tspinner.show('', '');
    const formattedData = this.showComplaints.map((item, index) => ({
      'Sr. No.': this.showComplaints.length - index,
      'Ticket Id': item.ticket_id,
      'Department': item.departments,
      'Zone': item.zone,
      'Ward': item.ward,
      'Create Date': item.create_date,
      'Days Open': item.number_of_open_days,
      'Status': item.status
    }));
    this.tspinner.hide();
    this.excel.exportAsExcelFile(formattedData, 'Complaints_Report');

  }

  activeRow: any = null;

  togglePrintOption(rowObj: any) {
    if (this.activeRow === rowObj) {
      this.activeRow = null;  // close if already open on same row
    } else {
      this.activeRow = rowObj;  // open on clicked row
    }
  }

  closePrintOption() {
    this.activeRow = null;
  }


}
